













































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import { EChainStatus, IChain } from '@zunta/configurations'
import Icon from '@/components/Icon.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import { ChainModule } from '@/store/modules/chain.module'
import { UserModule } from '@/store/modules/user.module'
import { ETableColumnType, ITableConfig } from '@/interfaces'
import Api from '@/api'
import Card from '@/components/Card.vue'
import Table from '@/components/tables/Table.vue'
import { FacilityModule } from '@/store/modules/facility.module'
import { BillingModule } from '@/store/modules/billing.module'
import { MODULE_ITEMS } from '@/constants'
import ButtonDownloadReport from '@/components/ButtonDownloadReport.vue'
import DropdownNav from '@/components/DropdownNav.vue'
import { PermissionsModule } from '@/store/modules/permissions.module'

@Component({
  name: 'AdminFacilities',
  components: {
    DropdownNav,
    ButtonDownloadReport,
    Table,
    Card,
    Icon,
    DateTimeLabel
  }
})
export default class AdminFacilities extends Vue {
  permissionsModuleInstance: PermissionsModule = getModule(PermissionsModule, this.$store)
  billingModuleInstance: BillingModule = getModule(BillingModule, this.$store)
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)
  userModuleInstance: UserModule = getModule(UserModule, this.$store)
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store);
  openedRow: any;
  openedRowIndex: number = -1;
  EChainStatus = EChainStatus;
  prevFilters: any = {};

  isLoading: boolean = false

  config: ITableConfig = {
    useQuery: true,
    usePagination: true,
    useSubrow: true,
    maxHeight: 'calc(100vh - 357px)',
    minHeight: '100px',
    fetchFunction: this.fetchFacilities,
    clearFilterBtn: {
      wrapperClass: 'position-absolute',
      wrapperStyle: 'top: -1rem; right: -1.5rem;',
      class: 'rounded-bottom'
    },
    columns: [
      {
        minWidth: '230px',
        width: 15,
        key: 'name',
        searchKey: 'name',
        hasSort: true,
        hasSearch: true,
        label: 'Name',
        type: ETableColumnType.default
      },
      {
        minWidth: '150px',
        width: 15,
        key: 'chainName',
        searchKey: 'chainName',
        hasSort: true,
        hasSearch: true,
        label: 'Chain',
        type: ETableColumnType.default
      },
      {
        minWidth: '120px',
        width: 9.5,
        key: 'invoiceStart',
        searchKey: 'invoiceStart',
        hasSearch: true,
        label: 'Start Date',
        type: ETableColumnType.dateRange
      },
      {
        minWidth: '120px',
        width: 9.5,
        key: 'invoiceEnd',
        searchKey: 'invoiceEnd',
        hasSearch: true,
        label: 'End Date',
        type: ETableColumnType.dateRange
      },
      {
        minWidth: '120px',
        width: 10,
        key: 'salesRep',
        searchKey: 'salesRep',
        hasSearch: true,
        label: 'Sales Rep.',
        type: ETableColumnType.default
      },
      {
        minWidth: '120px',
        width: 15,
        key: 'rate',
        searchKey: 'rate',
        hasSearch: true,
        label: 'Commission of SR',
        type: ETableColumnType.default
      },
      {
        minWidth: '120px',
        width: 10,
        key: 'manager',
        searchKey: 'manager',
        hasSort: true,
        hasSearch: true,
        label: 'Billing Contact',
        type: ETableColumnType.default
      },
      {
        class: '',
        minWidth: '120px',
        width: 10,
        key: 'modules',
        label: 'Modules',
        searchKey: 'modules',
        hasSearch: true,
        type: ETableColumnType.select,
        options: MODULE_ITEMS.map((item) => ({
          value: item.value,
          content: item.content,
          key: item.value
        }))
      },
      {
        class: 'text-right',
        minWidth: '100px',
        width: 5,
        key: 'actions',
        hasSearch: false
      }
    ]
  }

  get subRowConfig () {
    return {
      headless: true,
      columns: this.config.columns
    }
  }

  get facilitiesList () {
    return this.$store.state.billing.facilitiesWithCommissionSettings
  }

  get facilitiesTotal () {
    return this.$store.state.billing.facilitiesWithCommissionSettingsTotal
  }

  get rolesList () {
    return this.$store.state.permissions.roles
  }

  get dropdownOptions () {
    return (this.rolesList || []).map((role: any) => {
      return {
        key: role.id,
        value: role.id,
        content: role.name
      }
    })
  }

  openDetails (row: any, index: number) {
    if (index === this.openedRowIndex) {
      this.openedRowIndex = -1
      this.openedRow = null
    } else {
      this.openedRow = row
      this.openedRowIndex = index
    }
  }

  async fetchFacilities (query: any) {
    this.openedRowIndex = -1
    this.prevFilters = {
      ...query,
      withBillingSettings: true
    }
    await this.billingModuleInstance.fetchFacilitiesWithCommissionSettings(this.prevFilters)
  }

  async enterAsChain (chain: IChain, roleId?: number) {
    const token = await Api.auth.getChainManagerToken({
      chainId: chain.id,
      roleId: roleId || undefined
    })
    const routeData = this.$router.resolve({
      name: 'management-todo',
      query: {
        token
      }
    })
    this.$locationManager.openNewTab(routeData.href, true)
  }

  async getChainUserRoles (chain: IChain) {
    this.permissionsModuleInstance.UPDATE_ROLES_LIST([])
    this.isLoading = true
    await this.permissionsModuleInstance.getUserRoles(+chain.id)
    this.isLoading = false
  }
}
